import { Skeleton } from './Skeleton';
import { SkeletonCircle } from './SkeletonCircle';

/**
 * Skeleton for trip header section.
 * Matches the layout of TripHeader component.
 */
export const TripHeaderSkeleton = () => {
  return (
    <div className="relative h-[65vh] w-full overflow-hidden bg-muted">
      <div className="absolute bottom-0 left-0 w-full px-4 md:px-8 pb-12 pt-24 max-w-7xl mx-auto">
        <div>
          {/* Title skeleton */}
          <div className="mb-6 space-y-3">
            <Skeleton className="h-12 md:h-16 lg:h-20 w-3/4" />
            <Skeleton className="h-12 md:h-16 lg:h-20 w-1/2" />
          </div>

          <div className="flex flex-col md:flex-row md:items-end gap-6 md:gap-8">
            {/* Author skeleton */}
            <div className="flex items-center gap-3">
              <SkeletonCircle size="w-14 h-14" />
              <div className="space-y-2">
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-4 w-24" />
              </div>
            </div>

            {/* Description skeleton */}
            <div className="space-y-2 max-w-2xl border-l-2 border-subtle pl-4 md:pl-6">
              <Skeleton className="h-5 w-full" />
              <Skeleton className="h-5 w-5/6" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
